export default "__VITE_ASSET__Dy1o9bl5__"